import { AfterViewChecked, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router, RouterOutlet }                                   from '@angular/router';

import { Observable }  from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { routerAnimations } from '@shared/animations/animations';

import { Menu }     from '@models/navigation/menu';
import { AuthUser } from '@models/user/auth-user';

import { SiteSection } from '@models/layout/site-section';

import { LayoutService } from '../layout.service';
import { UserService }   from '@services/user.service';


@Component({
  selector:    'red-layout-institutional',
  templateUrl: './layout-institutional.component.html',
  styleUrls:   [ './layout-institutional.component.scss' ],
  animations:  [ routerAnimations ]
})
export class LayoutInstitutionalComponent implements AfterViewChecked, OnInit {

  public user$:        Observable<AuthUser>;
  public toolbarType$: Observable<SiteSection>;
  public toolbarMenu$: Observable<Menu>;

  constructor(
    private router:            Router,
    private changeDetectorRef: ChangeDetectorRef,
    private userService:       UserService,
    private layoutService:     LayoutService
  ) {
    this.user$        = this.userService.getActiveUser();
    this.toolbarType$ = this.layoutService.getSiteSection();
    this.toolbarMenu$ = this.layoutService.getToolbarMenu();
  }

  ngOnInit() {
    this.checkPartner();
  }

  public prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'] || null;
  }

  private checkPartner() {
    this.user$.pipe(
      filter((user: AuthUser) => !!(user && user.parceiroId)),
      map((user: AuthUser) => user.parceiroId)
    ).subscribe(partnerId => {
      if (partnerId === 2) this.router.navigate([ '/redacao/app/lista' ]).then();
    });
  }

  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

}
